import { QueryClient } from "@tanstack/react-query";

import { ApiError } from "@kansai-ai-hub/api-client";

function isRetryable(error: unknown): boolean {
  if (!(error instanceof ApiError)) return false;
  if ([401, 403, 404, 409, 422].includes(error.status)) return false;
  if ([0, 502, 503].includes(error.status)) return true;
  return false;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (!isRetryable(error)) return false;
        return failureCount < 2;
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 5000),
    },
    mutations: {
      retry: false,
    },
  },
});
